import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useState } from 'react'
import { AuthProvider } from './contexts/AuthContext'
import { ProjectProvider } from './contexts/ProjectContext'
import { ToastProvider } from './contexts/ToastContext'
import LoginPage from './pages/LoginPage'
import DashboardPage from './pages/DashboardPage'
import AuthCallbackPage from './pages/AuthCallbackPage'
import CompanySyncPage from './pages/CompanySyncPage'
import ProtectedRoute from './components/ProtectedRoute'
import SessionMonitor from './components/SessionMonitor'
import Sidebar from './components/Sidebar'
import PWAInstallPrompt from './components/PWAInstallPrompt'
import './App.css'

/**
 * Three-Legged Authentication App
 * Uses OAuth 2.0 Authorization Code Flow for user login
 * Users authenticate with their Autodesk accounts to access user profile information
 */

const AppLayout = ({ isSidebarOpen, setIsSidebarOpen, onOpenProjectsModal, projectsModalOpen, setProjectsModalOpen }) => {

  const closeSidebar = () => {
    setIsSidebarOpen(false)
  }

  return (
    <div className="app-layout">
      <Sidebar
        isMobileOpen={isSidebarOpen}
        onCloseMobile={closeSidebar}
        onOpenProjectsModal={onOpenProjectsModal}
      />
      <div className="app-main" onClick={closeSidebar}>
                        <Routes>
                          <Route path="/dashboard" element={<DashboardPage setIsSidebarOpen={setIsSidebarOpen} projectsModalOpen={projectsModalOpen} setProjectsModalOpen={setProjectsModalOpen} />} />
                          <Route path="/approvals/all" element={<DashboardPage setIsSidebarOpen={setIsSidebarOpen} projectsModalOpen={projectsModalOpen} setProjectsModalOpen={setProjectsModalOpen} />} />
                          <Route path="/fuel-module" element={<DashboardPage setIsSidebarOpen={setIsSidebarOpen} />} />
                          <Route path="/cost-module" element={<DashboardPage setIsSidebarOpen={setIsSidebarOpen} />} />
                          <Route path="/my-reviews" element={<DashboardPage setIsSidebarOpen={setIsSidebarOpen} />} />
                          <Route path="/templates" element={<DashboardPage setIsSidebarOpen={setIsSidebarOpen} />} />
                          <Route path="/reports" element={<DashboardPage setIsSidebarOpen={setIsSidebarOpen} />} />
                          <Route path="/compliance" element={<DashboardPage setIsSidebarOpen={setIsSidebarOpen} />} />
                          <Route path="/settings" element={<DashboardPage setIsSidebarOpen={setIsSidebarOpen} />} />
                          <Route path="/help" element={<DashboardPage setIsSidebarOpen={setIsSidebarOpen} />} />
                          <Route path="/company-sync" element={<CompanySyncPage setIsSidebarOpen={setIsSidebarOpen} />} />
                          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </div>
    </div>
  )
}

function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const [projectsModalOpen, setProjectsModalOpen] = useState(false)

  const handleOpenProjectsModal = () => {
    setProjectsModalOpen(true)
    setIsSidebarOpen(false) // Close sidebar when opening projects modal
  }

  return (
    <BrowserRouter>
      <AuthProvider>
        <ProjectProvider>
          <ToastProvider>
            <SessionMonitor />
            <PWAInstallPrompt />
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/callback" element={<AuthCallbackPage />} />
              <Route
                path="/*"
                element={
                  <ProtectedRoute>
                    <AppLayout
                      isSidebarOpen={isSidebarOpen}
                      setIsSidebarOpen={setIsSidebarOpen}
                      onOpenProjectsModal={handleOpenProjectsModal}
                      projectsModalOpen={projectsModalOpen}
                      setProjectsModalOpen={setProjectsModalOpen}
                    />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </ToastProvider>
        </ProjectProvider>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App
